import React, { Component } from "react";
import { Button, Modal, Row,Col,InputGroup} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import CreatableSelect from "react-select/creatable";
import Select from 'react-select';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt} from "@fortawesome/free-solid-svg-icons";

import Dictaphone from "../../../components/lib/Dictaphone/GcDictaphone";

import CoreService from "../../../services/CoreService";
import LocalStorageService from "../../../services/LocalStorageService";
import NotificationService from "../../../services/NotificationService";

import AddressBook from "../../../models/AddressBook";
import NotificationManager from "./NotificationManager";
import ServiceResponse from "../../../models/ServiceResponse";



const createOption = (label) => ({
  label,
  value: label,
});


export default class ShareDialog extends Component {
  constructor(props) {
    super(props);

    this.coreService = new CoreService();
    this.localStorageService = new LocalStorageService();
    this.notificationService = new NotificationService();

    this.state = {
        dataLoaded: false,
        listening: false,
        sending: false,
        sendToInputValue: "",
        sendToValue: [],
        msg: "",
        includePdfLink: true,
        addressBook: new AddressBook("", ""),  // {id: xxxxx, email: xxx@xxx.xxx, phone: +1xxx-xxx-xxxx}
        errMsg: "",
        schemaReports: [],
        selectedReports: []
    };

    this.onMsgChange = this.onMsgChange.bind(this);
    this.onTranscriptionChange = this.onTranscriptionChange.bind(this);
    this.onIncludePdfLinkChange = this.onIncludePdfLinkChange.bind(this);
    this.onSchemaReportValueChange = this.onSchemaReportValueChange.bind(this);
    this.validate = this.validate.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.cancelMessage = this.cancelMessage.bind(this);

  }

  componentDidMount()
  {
    if (this.localStorageService.hasLocalAddressBook(this.props.userSession?.gcid?? "", this.props.userSession?.uid?? ""))
    {
      var newAddressBook = this.localStorageService.getLocalAddressBook(this.props.userSession.gcid, this.props.userSession.uid);
      this.setState({addressBook: newAddressBook.data});
    } 
  }

componentDidUpdate(prevProps, prevState)
{
  if (prevProps.currentObservation != this.props.currentObservation)
  {
    this.setState({dataLoaded: true});
  }
}

  onMsgChange(ev){
    this.setState({msg: ev.target.value});
  }

  onTranscriptionChange(newTranscription)
  {
    var newValue = (this.state.msg) ? this.state.msg + " " + newTranscription : newTranscription;
    this.setState({msg: newValue});
  }

  onAddObsCommentRequest()
  {
    var comment = (this.props.currentObservation.data.Environment.Comments) ? this.props.currentObservation.data.Environment.Comments : "";
    var newValue = (this.state.msg) ? this.state.msg + " " + comment : comment;
    this.setState({msg: newValue});
  }

  onIncludePdfLinkChange(){
    this.setState({includePdfLink: (!this.state.includePdfLink)});
  }

  onSchemaReportValueChange(opts) 
  {
    //var newOpts = (Array.isArray(opts) ? opts.map(x => x.value) : []);
    this.setState({
        selectedReports: opts
    })
}

  addressBookIdExists(addressBook, testId)
  {
    if (!addressBook.addresses) return false;
    for (let i=0; i<addressBook.addresses.length; i++)
    {
      let addrBookId = addressBook.addresses[i].id;
      if (addrBookId.toLowerCase() === testId.value.toLowerCase()) return true;
    }
    return false;
  }

  cancelMessage()
  {
    this.setState(
    {
      sending: false,
      msg: "",
      errMsg: "",
      sendToInputValue: "",
      sendToValue: [], // clear   
      sendMsg: "",
      selectedReports: []
    });
    this.props.closeShareBox();
  }

  validate()
  {
    var hasError = false;
    var errMsgs = [];
    if (this.state.sendToValue.length < 1)
    {
      hasError = true;
      errMsgs.push("Please select at least one recipient.");
    }
    if ((this.state.selectedReports.length < 1) && (this.state.sendMsg === ""))
    {
      hasError = true;
      errMsgs.push("Please either select a report and/or a message to send to recipient(s).");
    }
    if (hasError)
    {
      return new ServiceResponse(true, errMsgs);
    }
    else 
    {
      return new ServiceResponse(false);
    }

  }


  async sendMessage()
  {
    try
    {
      this.setState({sending: true, sendMsg: "Validating..."});
      var validationResponse = this.validate();
      if (validationResponse.hasError)
      {
        var errMessage = validationResponse.messages.join("");
        this.setState({errMsg: errMessage});
        return;
      }
   
      this.setState({sending: true,sendMsg: "Sending your message..."});
      var newAddressBook = this.state.addressBook;

      for (let i=0; i<this.state.sendToValue.length; i++){
        var testId = this.state.sendToValue[i];
        if (!this.addressBookIdExists(newAddressBook, testId)){
          newAddressBook.addresses.push({id: testId.value, email: testId.value, phone:""});
        }
      }
      var recipients = this.state.sendToValue.map((recipient) =>{
        return recipient.value
      });
      this.setState({sendMsg: "Saving Address Book..."});
      this.localStorageService.saveLocalAddressBook(this.props.userSession.gcid, this.props.userSession.uid, newAddressBook);
      this.setState({addressBook: newAddressBook});

      this.setState({sendMsg: "Generating Reports..."});
      var hasError = false;
      if (this.state.selectedReports)
      {
        for(const rpt of this.state.selectedReports)
        {
            this.setState({sendMsg: "Creating " + rpt.label + "..."});
            this.setState({sendMsg: "Sending Email Notifications..."});
            var schemaReport = this.props.schemaReports.find((r) => r.id === rpt.value);
            var reportEmaiTemplateId = schemaReport.templates.email;

            var notificationsDataResponse = await new NotificationManager().getDirectNotificationResult(this.props.userSession.uid, recipients, this.state.msg, this.props.currentObservation, rpt.value, reportEmaiTemplateId, this.props.userSession.uid, this.props.userSession.gcid, this.props.userSession.token);
            var postResult = await this.notificationService.postDirectNotificationRequest(notificationsDataResponse.data, this.props.userSession.gcid, this.props.userSession.token);
            if (postResult.hasError)
            {
              hasError = true;
              var msgs = postResult.messages;
              msgs.unshift("Error sending email.");
              this.props.onToastRequest("error", msgs);
            }
            console.log("posted email");
        };
        if (hasError)
        {
          this.props.onToastRequest("warning", "Some email requests failed.");
        }
        else 
        {
          this.props.onToastRequest("success", "Email(s) sent successfully!");
        }
      }
      this.props.closeShareBox(); 
    }
    catch(e)
    {
      var errMsg = "There was a problem sending your message. (" + e.message + ")";
      this.setState({
        sending: false,
        errMsg: errMsg,
        sendMsg: ""
      });
      this.props.onToastRequest("error", "Error sending email (" + e.message + ")");
    }  
    finally
    {
        this.setState({
            sending: false,
            msg: "",
            sendToInputValue: "",
            sendToValue: [],
            sendMsg: "" // clear         
          })
    }
  }

  handleSendToChange = (value, actionMeta) => {
    //if (actionMeta.action==="remove-value"){
    //  let tagValue = actionMeta.removedValue.value;
    //}
    var newValue = (value) ? value: [];
    this.setState({ sendToValue: newValue });
  };

  handleSendToInputChange = (sendToInputValue) => {
    var newValue = (sendToInputValue) ? sendToInputValue: "";
    this.setState({ sendToInputValue: newValue });
  };

  handleSendToKeyDown = (event) => {
    const { sendToInputValue, sendToValue } = this.state;
    if (!sendToValue) return;
    if (!sendToInputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        //console.group("Value Added");
        //console.log(sendToValue);
        //console.groupEnd();
        this.setState({
          sendToInputValue: "",
          sendToValue: [...sendToValue, createOption(sendToInputValue)],
        });
        event.preventDefault();
    }
  };


  render() {

    const { sendToInputValue, sendToValue } = this.state;
    //console.group("Address book: ");
    //console.log(this.state.addressBook);
    const addressBookOptions = this.state.addressBook?.addresses?.map((addr) =>{return createOption(addr.email);});
    //console.log(addressBookOptions);
    //console.groupEnd();

    const schemaReportOptions = this.props.schemaReports?.map((s) => {return {value: s.id, label: s.label}});

    const sendingDiv = (this.state.sending) ?
      <div><FontAwesomeIcon icon={faSyncAlt} spin={true}/>&nbsp; {this.state.sendMsg}...</div>
      : "";


    return (
      <Modal show={this.props.showShareBox} onHide={this.props.closeShareBox}>
        <Modal.Header closeButton>
          <Modal.Title>Share Observation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row><Col>Send To</Col></Row>
          <Row>
            <Col>
            <CreatableSelect
                  //components={components}
                  inputValue={sendToInputValue}
                  isClearable
                  isMulti
                  isDisabled={false}
                  options={addressBookOptions}
                  onChange={this.handleSendToChange}
                  onInputChange={this.handleSendToInputChange}
                  onKeyDown={this.handleSendToKeyDown}
                  placeholder="Enter the recipient's e-mail address here"
                  value={sendToValue}
                />
            </Col>
          </Row>
          <Row><Col>Message</Col></Row>
          <Row><Col><Button><Dictaphone onTranscriptionChange={this.onTranscriptionChange}/></Button></Col></Row>
          <Row>
            <Col>

            <InputGroup size="sm" className="textcard-input">
            <textarea
              rows={4}
              cols={50}
              autoFocus
              //textAlign="center"
              placeholder="Enter your message here..."
              aria-describedby="basic-addon2"
              name="msgComment"
              value={this.state.msg}
              onChange={this.onMsgChange}
            />
            </InputGroup>
            </Col>
          </Row>
          <Row>
            <Col>
            <Button variant="light" size='sm' disabled={(!this.props?.currentObservation?.data?.Environment?.Comments)} onClick={this.onAddObsCommentRequest.bind(this)}>Add Observation Comment</Button>  
            </Col>
          </Row>
          <Row><Col>Include Reports?</Col></Row>
          <Row>
            <Col>
            <Select
                autoFocus
                placeholder={"Select reports to include (not required)"}
                options={schemaReportOptions}
                onChange={opts => this.onSchemaReportValueChange(opts)}
                isSearchable={true}
                isMulti={true}
                value={this.state.selectedReports}
                                />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" disabled={!this.state.dataLoaded} onClick={(e) => this.sendMessage(e)}>
            Send
          </Button>
          <Button variant="secondary" onClick={this.cancelMessage}>
            Cancel
          </Button>
          {(this.state.errMsg.trim() === "") ? <span/> : <span style={{color: "red", fontSize: "8pt"}}>&nbsp;&nbsp;{this.state.errMsg}</span>}
          <div>
            {sendingDiv}
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}
